/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-black': {
    width: 16,
    height: 16,
    viewBox: '0 0 8.62 13.86',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M1.7 13.86l6.92-6.93L1.7 0 0 1.72l5.21 5.21L0 12.14l1.7 1.72z" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/arrow-black.js